import { IPartnerFlag } from 'clickNgo/entities/partner/models/partnerFlag'
import { I577Form } from 'clickNgo/models/crud/forms/i577Form'

export const mapPartnerFlagFrom577Crud = (data: I577Form): IPartnerFlag => ({
  entryId: data.EntryID || '',
  partnerId: data.PARTNER_ID || '',
  code: data.Code || '',
  codeName: data.CodeName || '',
  startDate: new Date(data.START_DATE),
  endDate: new Date(data.END_DATE),
  apolloCode: data.ApolloCode || '',
  codeType: data.CodeType || '',
  agreementNumber: data.AgreementNo || '',
  revision: data.Revision,
  currency: data.Currency || '',
  signatureDate: data.SIGNATURE_DATE,
  topPartnerId: data.TopPartnerID || '',
  region: data.GeoRegion || '',
})
